import { render, staticRenderFns } from "./Statement.component.vue?vue&type=template&id=50a390bd&"
import script from "./Statement.component.vue?vue&type=script&lang=ts&"
export * from "./Statement.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports